/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Highlight_Security_TitleInputs */



/**
* | output |
* | --- |
* | "Security-first architecture" |
*
* @param {Pricing_Highlight_Security_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_highlight_security_title = /** @type {((inputs?: Pricing_Highlight_Security_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Highlight_Security_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sicherheitsorientierte Architektur")
	return /** @type {LocalizedString} */ ("Security-first architecture")
});